import { render, staticRenderFns } from "./social-buttons.vue?vue&type=template&id=3f96498e&scoped=true"
import script from "./social-buttons.vue?vue&type=script&lang=js"
export * from "./social-buttons.vue?vue&type=script&lang=js"
import style0 from "./social-buttons.vue?vue&type=style&index=0&id=3f96498e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f96498e",
  null
  
)

export default component.exports